export default __webpack_public_path__ + "static/Gibson-SemiBold-d3c8718f8951de3f1856847fafde3348.woff2";